import {
  BUTTON_SUBMISSION,
  OVERLAY,
  ADD_TO_QUOTE,
  CREATE_A_QUOTE,
  QUOTE_ADD,
  NEW_QUOTE_ADD,
  DELIVERY_ZIP_OVERLAY_EVENT,
  STASH, ERROR
} from '../constants';
import { getPageType } from '../thd-analytics-utils';

export const addToQuote = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('add-to-quote.addToQuoteOverlay', () => {
    const DDOEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: ADD_TO_QUOTE
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('add-to-quote.createAQuoteOverlay', () => {
    const DDOEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: CREATE_A_QUOTE
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('add-to-quote.quoteAdd', ({ output }) => {
    const { quoteType, quoteId, item = [], quoteTimeElapsed } = output;
    const quoteLocation = getPageType();

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: QUOTE_ADD
      },
      quoteType,
      quoteId,
      quoteTimeElapsed,
      item: item.map((product) => ({
        ...product,
        quoteLocation
      }))
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('add-to-quote.newQuoteAdd', ({ output }) => {
    const { quoteType, quoteId, item = [], quoteTimeElapsed } = output;
    const quoteLocation = getPageType();

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: NEW_QUOTE_ADD
      },
      quoteType,
      quoteId,
      quoteTimeElapsed,
      item: item.map((product) => ({
        ...product,
        quoteLocation
      }))
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('add-to-quote.deliveryZipCodeOverlay', () => {
    const deliveryZipOverlayEventData = {
      category: {
        primaryCategory: 'button submission',
      },
      eventInfo: { eventName: 'my account settings' },
      myAccount: { settings: 'add to quote overlay: delivery zip changed' },
    };
    digitalData.event.push(deliveryZipOverlayEventData);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('add-to-quote.closeQuote', ({ output }) => {
    const { settings = '' } = output;

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: 'my account settings'
      },
      myAccount: {
        settings
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('add-to-quote.quoteNameLink', () => {

    const DDOEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: 'my account settings'
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: 'add to quote overlay: success: quote name link'
        }
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('add-to-quote.errorAnalytics', ({ output }) => {
    const { error = [] } = output;

    const DDOEvent = {
      category: {
        primaryCategory: ERROR
      },
      eventInfo: {
        eventName: 'post page error'
      },
      error
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('add-to-quote.loadingScreen', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'add to quote loading screen'
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('add-to-quote.closeLoadingScreen', ({ output }) => {
    const { settings = '' } = output;
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: 'my account settings'
      },
      myAccount: {
        settings
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};
